import { useState } from 'react';
import { Button, ImageCropper } from '@repo/ui-web';

const sampleImage =
  'data:image/svg+xml,%3Csvg xmlns%3D%22http://www.w3.org/2000/svg%22 width%3D%22400%22 height%3D%22400%22 viewBox%3D%220 0 400 400%22%3E%3Cdefs%3E%3ClinearGradient id%3D%22g%22 x1%3D%220%25%22 y1%3D%220%25%22 x2%3D%22100%25%22 y2%3D%22100%25%22%3E%3Cstop offset%3D%220%25%22 stop-color%3D%22%230ea5e9%22/%3E%3Cstop offset%3D%22100%25%22 stop-color%3D%22%231f2937%22/%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width%3D%22400%22 height%3D%22400%22 fill%3D%22url(%23g)%22/%3E%3Ccircle cx%3D%22200%22 cy%3D%22150%22 r%3D%2265%22 fill%3D%22%23fff%22 fill-opacity%3D%220.7%22/%3E%3Crect x%3D%22120%22 y%3D%22230%22 width%3D%22160%22 height%3D%2280%22 rx%3D%2240%22 fill%3D%22%23fff%22 fill-opacity%3D%220.7%22/%3E%3C/svg%3E';

export function ImageCropperShowcase() {
  const [cropShape, setCropShape] = useState<'round' | 'rect'>('round');
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1.2);

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center gap-2">
        <Button
          type="button"
          size="sm"
          variant={cropShape === 'round' ? 'default' : 'outline'}
          onClick={() => setCropShape('round')}
        >
          Round crop
        </Button>
        <Button
          type="button"
          size="sm"
          variant={cropShape === 'rect' ? 'default' : 'outline'}
          onClick={() => setCropShape('rect')}
        >
          Square crop
        </Button>
      </div>

      <div className="relative h-72 w-full max-w-sm overflow-hidden rounded-2xl border border-input bg-muted">
        <ImageCropper
          image={sampleImage}
          crop={crop}
          zoom={zoom}
          cropShape={cropShape}
          showGrid
          onCropChange={setCrop}
          onZoomChange={setZoom}
        />
      </div>

      <div className="max-w-sm space-y-2">
        <label htmlFor="image-cropper-zoom" className="text-sm font-medium text-foreground">
          Zoom
        </label>
        <input
          id="image-cropper-zoom"
          type="range"
          min={1}
          max={3}
          step={0.05}
          value={zoom}
          onChange={(event) => setZoom(Number(event.target.value))}
          className="w-full accent-primary"
        />
        <p className="text-xs text-muted-foreground">Drag image to reposition crop area.</p>
      </div>
    </div>
  );
}
